import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

const NavigationBlocker = ({ isNavigationBlocked }) => {
  const history = useHistory();
  const location = useLocation();
  const pathname = location?.pathname || '';
  const isCustomPageEditorRoute = /^\/admin\/pages\/(\d+)\/edit$/.test(pathname)
    || pathname === '/admin/pages/add';

  useEffect(() => {
    if (isCustomPageEditorRoute) {
      return () => {};
    }

    const unblock = history.block(() => {
      if (isNavigationBlocked) {
        return false;
      }
      return true;
    });

    return () => {
      unblock();
    };
  }, [history, isNavigationBlocked, isCustomPageEditorRoute]);

  return null;
};

const mapStateToProps = state => ({
  isNavigationBlocked: state.App.isNavigationBlocked,
});

NavigationBlocker.propTypes = {
  isNavigationBlocked: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(NavigationBlocker);
